import { ArraySchema } from "@colyseus/schema"

export function shuffleArraySchema<T>(array: ArraySchema<T>): ArraySchema<T> {
  const temp = [...array]
  let currentIndex = temp.length

  while (currentIndex > 0) {
    const randomIndex = Math.floor(
      (crypto.getRandomValues(new Uint32Array(1))[0] / (0xffffffff + 1)) *
        currentIndex
    )
    currentIndex--
    const tempValue = temp[currentIndex]
    temp[currentIndex] = temp[randomIndex]
    temp[randomIndex] = tempValue
  }

  for (const [i, element] of temp.entries()) array[i] = element

  return array
}
